"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'step.delete.confirm.title': '删除步骤',
    'step.delete.confirm.message': '确定要删除此步骤吗？',
};
